<template>
    <div class="attendanceAdmin">
        <div class="searchCont">
            <div class="searchContLeft">
                <el-form :inline="true" :model="searchForm" label-width="120">
                    <el-form-item label="年份" size="mini">
                        <el-date-picker
                            v-model="searchForm.year"
                            type="year"
                            placeholder="选择年"
                            value-format="yyyy"
                            format="yyyy"
                            size="mini"
                        >
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态" size="mini">
                        <el-select
                            clearable
                            v-model="searchForm.status"
                            size="mini"
                            placeholder="请选择状态"
                            @change="getAttendance"
                        >
                            <el-option
                                v-for="item in statusList"
                                :key="item.status"
                                :label="item.name"
                                :value="item.status"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <el-button
                    icon="el-icon-search"
                    size="mini"
                    type="primary"
                    style="margin-right:10px"
                    @click="getAttendance(1)"
                ></el-button>
                <div v-if="this.menuAuth">
                    <template v-for="item in menuAuth.slice(0, 2)">
                        <el-button
                            type="primary"
                            :key="item.id"
                            :icon="item.icon"
                            size="mini"
                            @click="authFunc(item.funcName)"
                        >
                            {{ item.name }}
                        </el-button>
                    </template>
                    <el-dropdown
                        v-if="menuAuth.length > 2"
                        @command="authFunc"
                        style="margin-left:10px"
                    >
                        <el-button
                            type="primary"
                            size="mini"
                            icon="el-icon-arrow-down"
                        >
                            更多操作
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item
                                :key="item.id"
                                v-for="item in menuAuth.slice(2)"
                                :command="item.funcName"
                            >
                                <i :class="item.icon"> </i>
                                {{ item.name }}
                            </el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </div>
                <div v-else></div>
            </div>
            <!-- <el-button
                    class="el-icon-s-fold searchDrawer"
                    type="text"
                    size="mini"
                    @click="drawerVisible = true"
                    >高级搜索</el-button
                > -->
        </div>
        <div class="table" :style="{ height: screen }">
            <el-table
                :data="tableData"
                ref="tableData"
                highlight-current-row
                height="100%"
            >
                <el-table-column
                    type="selection"
                    align="left"
                    :fixed="checkFixed"
                >
                </el-table-column>
                <el-table-column label="年月" align="left">
                    <template slot-scope="scope">
                        {{ scope.row.year }}-{{ scope.row.month }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="考勤人数"
                    property="user_num"
                    align="left"
                ></el-table-column>
                <el-table-column
                    label="制单人"
                    property="creater"
                    align="left"
                ></el-table-column>
                <el-table-column
                    label="制单时间"
                    property="create_at"
                    align="left"
                ></el-table-column>
                <el-table-column label="报告" align="left">
                    <template slot-scope="scope">
                        <el-button
                            @click="report(scope.row)"
                            type="text"
                            size="small"
                        >
                            查看
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column label="状态" property="status" align="left">
                    <template slot-scope="scope">
                        {{
                            scope.row.status == 0
                                ? "待确认"
                                : scope.row.status == 5
                                ? "待处理"
                                : "已完结"
                        }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="left"
                    width="200"
                    :fixed="operationFixed"
                >
                    <template slot-scope="scope">
                        <div class="color-blue">
                            <el-button
                                type="text"
                                size="small"
                                class="color-blue"
                                v-if="scope.row.status == 0"
                                @click="showConfirm('sure', scope.row)"
                                >确认</el-button
                            >
                            <el-button
                                type="text"
                                size="small"
                                class="color-blue"
                                v-if="scope.row.status == 5"
                                @click="showConfirm('dispose', scope.row)"
                                >处理</el-button
                            >
                            <el-button
                                type="text"
                                size="small"
                                class="color-blue"
                                @click="detail(scope.row)"
                                >详情</el-button
                            >
                            <el-button
                                type="text"
                                size="small"
                                style="color:red"
                                v-if="scope.row.status == 0"
                                @click="showConfirm('del', scope.row)"
                                >删除</el-button
                            >
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <pagination
            :paginationData="paginationData"
            @paginationChange="paginationChange"
        ></pagination>
        <report
            :reportVisible.sync="reportVisible"
            :tableItem.sync="tableItem"
            ref="childReport"
        ></report>
        <detail
            :detailVisible.sync="detailVisible"
            :tableItem.sync="tableItem"
            ref="childDetail"
        ></detail>
    </div>
</template>
<script>
import * as oaApi from "@/http/oaApi.js";
import pagination from "@/comon/components/pagination";
import report from "./attendanceAdmin/report";
import detail from "./attendanceAdmin/detail";
export default {
    data() {
        return {
            total: "",
            statusList: [
                { name: "待处理", status: 0 },
                { name: "待确认", status: 5 },
                { name: "已完结", status: 10 }
            ],
            searchForm: {
                status: "",
                year: String(new Date().getFullYear())
            },
            tableData: [],
            paginationData: {
                page: 1,
                "per-page": 20,
                total: ""
            },

            reportVisible: false,
            attendanceVisible: false,
            detailVisible: false,
            searchFormH: ""
        };
    },
    components: {
        pagination: pagination,
        report: report,
        detail: detail
    },
    methods: {
        // 获取考勤列表数据
        getAttendance(page) {
            page ? (this.paginationData.page = 1) : "";
            oaApi
                .attendance(
                    {
                        ...this.searchForm,
                        ...this.paginationData
                    },
                    "get"
                )
                .then(res => {
                    if (res) {
                        this.tableData = res.data;
                        this.paginationData.total = res.total;
                        this.$refs.tableData.bodyWrapper.scrollTop = 0;
                    }
                });
        },
        // 回车事件
        enterKeyUp(e) {
            let key = window.event.keyCode || e.keyCode;
            if (key === 13) {
                if (this.reportVisible) {
                    if (this.$refs.childReport.reportDetailVisible) {
                        this.$refs.childReport.$refs.childreportDetail.getDetail();
                    } else {
                        this.$refs.childReport.getReport();
                    }
                } else if (this.detailVisible) {
                    this.$refs.childDetail.getDetail();
                } else {
                    this.getAttendance(1);
                }
            }
        },
        paginationChange(paginationData) {
            this.paginationData = paginationData;
            this.getAttendance();
        },
        // 查看报告
        report(row) {
            this.tableItem = row;
            this.reportVisible = true;
        },
        /**
         * 考勤导入按钮
         */
        attexport() {
            this.attendanceVisible = true;
        },
        /**
         * confirm框
         */
        showConfirm(text, row) {
            let font = "";
            let url = "";
            if (text == "sure") {
                font = "提交处理";
                url = "attendanceConfirm";
            } else if (text == "dispose") {
                font = "已完结";
                url = "attendanceFinish";
            } else if (text == "del") {
                font = "删除";
                url = "attendance";
            }
            this.$confirm(`确定${font}?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            })
                .then(() =>
                    oaApi[url](
                        {
                            id: url == "attendance" ? "" : row.id
                        },
                        url == "attendance" ? "delete" : "post",
                        url == "attendance" ? row.id : ""
                    ).then(res => {
                        if (res) {
                            if (res.code == 200) {
                                this.$message.success(`${font}成功`);
                                this.getAttendance();
                            }
                        }
                    })
                )
                .catch(() => {
                    this.$message.info("已取消操作");
                });
        },
        /**
         * 详情
         */
        detail(row) {
            this.tableItem = row;
            this.detailVisible = true;
        },
        authFunc(funcName) {
            this[funcName]();
        }
    },
    mounted() {
        this.getAttendance();
    },
    created() {
        document.addEventListener("keydown", this.enterKeyUp);
    },
    destroyed() {
        document.removeEventListener("keydown", this.enterKeyUp);
    },
    watch: {
        perPage: {
            handler(newValue) {
                this.perPage = newValue;
                this.getAttendance();
            },
            deep: true,
            immediate: false
        },
        page: {
            handler(newValue) {
                this.page = newValue;
                this.getAttendance();
            },
            deep: true,
            immediate: false
        }
    },
    computed: {
        menuAuth() {
            return this.$store.state.menu.menuAuth;
        },
        screen() {
            return `calc(100% - 40px - 40px)`;
        }
    }
};
</script>
<style lang="scss">
.attendanceAdmin {
    height: 100%;
    background: #fff;
    width: 100%;
    box-sizing: border-box;
    padding: 0 20px;
    .containerTitle {
        line-height: 40px;
        font-size: 14px;
        width: 100%;
        border-bottom: 1px solid #ddd;
        text-align: left;
        text-indent: 14px;
    }
    .table {
        height: calc(100% - 41px - 61px - 72px);
    }
}
</style>
